<template>
    <div>
        <h1 class="page_ttl">ページが見つかりません</h1>
        <div class="region region-content">
            <div
                id="block-meinheshikontentsu"
                class="block block-system block-system-main-block"
            >
                リクエストされたページが見つかりません。
            </div>
        </div>
    </div>
</template>

<script></script>

<style scoped></style>
